import { University } from '../types';

export enum UniversityActionType {
    GET_UNIVERSITY = 'GET_UNIVERSITY',
    UPDATE_UNIVERSITY = 'UPDATE_UNIVERSITY',
}

interface GetUniversityAction {
    type: UniversityActionType.GET_UNIVERSITY;
    payload: University;
}

interface UpdateUniversityAction {
    type: UniversityActionType.UPDATE_UNIVERSITY;
    payload: University;
}

export type UniversityAction = GetUniversityAction | UpdateUniversityAction;
